module.exports = __webpack_public_path__ + "static/logo-4eb0bad8e68ed28553207102bda00188.png";